// components/ui/Button.jsx
import React from "react";
import clsx from "clsx";

/** Dégradés (plus de jaune, moins de vert) */
const BRAND = {
  // jaune -> vert avec plus de jaune visible
  primary: "from-[#FFD76A] via-[#FFD76A] to-[#FFD76A]",
  mint: "from-[#D19E22] via-[#E0CE49] to-[#86A93A]",
  coral: "from-[#FFD76A]/50  to-[#FFD76A]/50",
};

/** Tailles */
const SIZES = {
  sm: "text-sm px-4 py-2",
  md: "text-base px-5 py-3",
  lg: "text-base px-6 py-3.5",
};

/** Base: affichage du texte corrigé */
const baseSolid = `
inline-flex items-center justify-center gap-2 rounded-full font-semibold text-[#3a3a3a] leading-[1.4]
transition-all duration-300
bg-gradient-to-br
bg-[length:180%_180%] bg-[position:0%_50%] hover:bg-[position:100%_50%]
shadow-[0_6px_18px_rgba(99,198,106,0.28)] hover:shadow-[0_10px_24px_rgba(99,198,106,0.40)]
hover:scale-[1.015] active:scale-95 
focus:outline-none focus-visible:ring-2 focus-visible:ring-black/10
`;

const PINEAPPLE_CORNER = `
[--tw-gradient-from-position:8%] [--tw-gradient-via-position:12%]
`;

const iconClass = "h-5 w-5 shrink-0";

export default function Button({
  children,
  color = "primary",
  size = "md",
  fullWidth = false,
  disabled = false,
  leftIcon,
  rightIcon,
  as = "button",
  href,
  className,
  ...rest
}) {
  const Comp = as === "a" ? "a" : "button";
  const isDelete = as === "delete";

  return (
    <Comp
      href={as === "a" ? href : undefined}
      disabled={as === "button" || isDelete ? disabled : undefined}
      type={as === "button" || isDelete ? "button" : undefined}
      className={clsx(
        // Appliquer baseSolid et les styles normaux UNIQUEMENT si ce n'est PAS delete
        !isDelete && baseSolid,
        !isDelete && SIZES[size],
        !isDelete && BRAND[color],
        // Style minimaliste pour delete : juste du texte rouge
        isDelete &&
          "inline-flex items-center gap-2 text-red-600 hover:text-red-700 font-semibold transition-colors duration-200 [&_svg]:text-red-600 hover:[&_svg]:text-red-700 px-0 py-0 bg-transparent border-0 shadow-none",
        fullWidth && "w-full",
        disabled && "opacity-50 pointer-events-none",
        className
      )}
      {...rest}
    >
      {leftIcon && <span className={iconClass}>{leftIcon}</span>}
      <span className="whitespace-nowrap">{children}</span>
      {rightIcon && <span className={iconClass}>{rightIcon}</span>}
    </Comp>
  );
}
